// Design tokens for the "Reimbursement Receipts Custom" tab.
//
// This is the custom-analytics "Field Command" design system re-skinned to
// Livable's brand: dark-on-light instead of light-on-dark, Livable teal/green
// in place of Squatch amber/pine. Shared between the CSS-in-JS styles and the
// ECharts options so the charts and the chrome stay in lockstep.

export const COLORS = {
  appBg: '#f8f9fa',
  // page background (Livable light gray)
  panel: '#ffffff',
  // card surface
  panelRaised: '#ffffff',
  border: 'rgba(33, 41, 52, 0.10)',
  borderStrong: 'rgba(33, 41, 52, 0.18)',
  text: '#212934',
  // Livable navy
  textMuted: '#4b617c',
  // slate
  textFaint: '#8895a7',
  // muted slate
  teal: '#009299',
  // Livable primary
  tealBright: '#00b1ba',
  green: '#00b488',
  // positive / paid (brand green)
  paid: '#00b488',
  credited: '#2a85d1',
  // blue — matches the legacy dashboard
  unpaid: '#c43131',
  // red — matches the legacy dashboard
  slate: '#4b617c',
  coral: '#ff8b7b',
  gold: '#eb996e'
};

// Semantic colors for the three reimbursement measures. Kept identical in
// meaning to the legacy Recharts dashboard so a user switching tabs reads the
// same color story (green = recovered, red = outstanding, blue = credited).
export const MEASURE = {
  paid: COLORS.paid,
  unpaid: COLORS.unpaid,
  credited: COLORS.credited
};

// Ordered categorical series palette for charts (e.g. charge-type donut).
export const SERIES = [COLORS.teal, COLORS.green, COLORS.slate, COLORS.coral, COLORS.credited, COLORS.gold, '#a06f93', '#6e8ca0'];

// Livable does not ship Oswald/Hanken; use a neutral system stack that matches
// the surrounding MUI typography so the canvas text blends with the DOM text.
export const FONT_BODY = "'Helvetica Neue', Helvetica, Arial, sans-serif";
export const FONT_MONO = "'SFMono-Regular', Menlo, Consolas, monospace";

// hex (#rrggbb) -> rgba(r,g,b,a)
export const withAlpha = (hex, a) => {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(a, ")");
};